<!--
 * @Author: zxf
 * @Date: 2022-08-08 16:50:37
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:48:19
 * @Description: 检测项管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page--inner l-page--search"
  >
    <!-- 查询条件 Start -->
    <div class="l-page__item u-mg-b-10">
      <!-- 查询条件表单 Start -->
      <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
      <el-form
        ref="filterParams"
        class="c-form c-condition__form"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-width="90px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="检查内容"
              prop="jcnr"
            >
              <select-sb
                v-model="filterParams.jcnr"
                clearable
                type="jc"
                show-all
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="6"
          >
            <el-form-item
              class="c-form__item"
              label="检测结果"
              prop="jcjg"
            >
              <el-select
                v-model="filterParams.jcjg"
                clearable
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择检测结果"
              >
                <el-option
                  value="Y"
                  label="合格"
                />
                <el-option
                  value="N"
                  label="不合格"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="6"
          >
            <el-form-item
              class="c-form__item"
              label="检测点与明细数"
              prop="jcdmxs"
              label-width="120px"
            >
              <el-select
                v-model="filterParams.jcdmxs"
                clearable
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择"
              >
                <el-option
                  value="Y"
                  label="相同"
                />
                <el-option
                  value="N"
                  label="不同"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 查询条件表单 End -->

          <el-col
            class="c-form__col o-form-btns u-mg-t-10 u-text-right"
            :span="24"
          >
            <k-button
              btn-text="查询"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-search"
              @click="refreshSearch()"
            />
            <k-button
              btn-text="重置"
              :auth-type="false"
              icon="kestrel-icon ki-repeat"
              @click="resetForm()"
            />
            <k-button
              btn-text="保存检测项"
              :auth-type="true"
              type="primary"
              icon="kestrel-icon ki-save"
              plain
              @click="handleSave"
            />

            <k-button
              btn-text="核对检测项"
              :auth-type="true"
              type="success"
              icon="kestrel-icon ki-snippets-fill"
              @click="handleHdjc()"
            />
            <span
              class="u-fl u-text-primary u-inline-block u-mg-t-10"
            >（已检测：{{ yjcxs }} 、 未检测：{{ wjcxs }}）</span>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div class="l-page__body l-page--search__body">
      <k-table-infinite
        v-loading="loading"
        :infinite-scroll-disabled="isDisabled"
        :infinite-scroll-immediate="false"
        height="100%"
        :table-column="tableColumn"
        :data="page.rows"
        @infiniteLoad="getDataNextPage"
      >
        <template #jcds="scope">
          <el-input-number
            v-model="scope.row.jcds"
            class="c-form__input-number"
            :min="scope.row.instance > 0 ? scope.row.instance : 0"
            :precision="0"
            label="请输入检测点数"
          />
        </template>
        <template #jcjgDm="scope">
          <span
            :class="{
              'u-text-success' : (scope.row.jcjg==='合格') ,
              'u-text-danger' : (scope.row.jcjg!=='合格')
            }"
          >
            {{ scope.row.jcjg === '合格' ? '合格' : '不合格' }}
          </span>
        </template>
        <template #bz="scope">
          <el-input
            v-model="scope.row.bz"
            class="c-form__input"
            type="text"
            placeholder="请输入备注"
          />
        </template>
      </k-table-infinite>
    </div>
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>
<script>
import { jcxService } from '../jcx/jcx.service';
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import KTableInfinite from '../../../components/KTable/KTableInfinite.vue';
export default {
  name: 'JcxIndex',
  components: { KTableInfinite },
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      isLoadFlag: false, // 加载标志
      isMore: false, // 更多标志
      isDisabled: false, // 可不用标志
      loadedPageNo: 0, // 已加载页码

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null,
        jcnr: null, // 检查内容
        jcjg: null, // 检测结果
        jcdmxs: null // 检测点与明细数
      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNo: 0,
        totalPages: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'bh', label: '编号', align: 'left', width: '80', type: 'text' },
        { key: 'jcx', label: '检测项', align: 'left', minWidth: '150', type: 'text' },
        { key: 'jcbz', label: '检测标准（规范要求）', align: 'left', minWidth: '180', type: 'text' },
        { key: 'zydj', label: '重要等级', align: 'center', width: '80', type: 'text' },
        { key: 'jcds', slotName: 'jcds', label: '检测点数', align: 'center', width: '140', type: 'text' },
        { key: 'bhgds', label: '不合格点数', align: 'center', width: '80', type: 'text' },
        { key: 'mxsl', label: '明细数量', align: 'center', width: '80', type: 'text' },
        { key: 'jcjgDm', slotName: 'jcjgDm', label: '检测结果', align: 'center', width: '80', type: 'text' },
        { key: 'bz', slotName: 'bz', label: '备注', align: 'left', minWidth: '120', type: 'text' }
      ],
      /* 表格列配置End */
      yjcxs: 0, // 已检测项
      wjcxs: 0, // 未检测项
      xmId: null // 检测项目ID
    };
  },
  methods: {
    getDataNextPage () {
      if (this.loadedPageNo === this.page.pageNo + 1) {
        // this.loading = false;
      } else if (this.loadedPageNo !== this.page.pageNo + 1 && this.page.pageNo < this.page.totalPages) {
        // this.loading = true;
        this.isMore = true;
        this.isDisabled = false;
        this.search(this.page.pageNo + 1);
      } else {
        // this.loading = false;
        this.isMore = false;
        this.isDisabled = true;
      }
    },
    /**
     * @description: 核对数据项
     * @return {*}
     */
    handleHdjc (_pageNo = 1) {
      const _this = this;
      this.page.rows = [];
      this.page.pageNo = 0;
      this.page.totalPages = 0;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      /* 处理分页参数 Start */
      _this.trueFilterParams.pageSize = this.page.pageSize;
      _this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */
      this.loading = true;
      _this.loadedPageNo = _pageNo;
      console.log(_this.xmId);

      this.page.rows.forEach(r => {
        r.jcds = r.mxsl;
      });
      jcxService.getJcxhdPage(_this.trueFilterParams)
        .then(rsp => {
          _this.page.pageNo = rsp.data.pageNo;
          _this.page.totalPages = rsp.data.totalPages;
          _this.page.rows = _this.page.rows.concat(rsp.data.rows);

          if (_this.page.pageNo < _this.page.totalPages) {
            _this.isMore = true;
            _this.isDisabled = false;
          }
          this.$alert('核对成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });

          this.getJcxCountInfo();
        })
        .catch(err => {
          console.error('核对检测项出错！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 获取检测项统计信息
     * @return {*}
     */
    getJcxCountInfo () {
      jcxService.getJcxCountInfo(this.xmId)
        .then(rsp => {
          this.wjcxs = rsp.data.data.wjcxs;
          this.yjcxs = rsp.data.data.yjcxs;
          this.$emit('updateJcx', rsp.data.data);
        })
        .catch(err => {
          console.error('获取检测项统计信息出错！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      for (let i = 0; i < this.page.rows.length; i++) {
        this.page.rows[i].jcjg = (this.page.rows[i].jcds === Number(this.page.rows[i].mxsl)) && (Number(this.page.rows[i].bhgds) === 0) ? '合格' : '不合格';
      }
      // 检测点数检验
      const max = 2147483647;
      const jcdsList = this.page.rows.filter(jcx => jcx.jcds > max);
      if (jcdsList.length > 0) {
        this.$message({
          message: `【检测点数】最大值不能超过${max}`,
          type: 'warning'
        });
        this.loading = false;
        return;
      }
      // 备注检验
      const maxLength = 300;
      const bzList = this.page.rows.filter(jcx => jcx.bz && jcx.bz.length > maxLength);
      if (bzList.length > 0) {
        this.$message({
          message: `【备注】长度不能超出${maxLength}位`,
          type: 'warning'
        });
        this.loading = false;
        return;
      }
      jcxService.saveJcx(this.xmId, this.page.rows)
        .then(rsp => {
          this.$alert('保存成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.getJcxCountInfo();
        })
        .catch(err => {
          console.error('检测项保存出错！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.page.rows = [];
      this.page.pageNo = 0;
      this.page.totalPages = 0;
      this.loading = true;

      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      if (this.filterParams.jcnr && this.filterParams.jcnr.includes('/')) {
        [this.trueFilterParams.jcnrId, this.trueFilterParams.jcdId] = this.filterParams.jcnr.split('/');
      }

      this.search(1);
      this.getJcxCountInfo();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      const _this = this;
      /* 处理分页参数 Start */
      _this.trueFilterParams.pageSize = this.page.pageSize;
      _this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      _this.loading = true;
      _this.loadedPageNo = _pageNo;
      console.log(_this.xmId);
      jcxService.queryJcx(_this.trueFilterParams)
        .then(rsp => {
          _this.page.pageNo = rsp.data.pageNo;
          _this.page.totalPages = rsp.data.totalPages;
          _this.page.rows = _this.page.rows.concat(rsp.data.rows);
          for (let i = 0; i < _this.page.rows.length; i++) {
            if (Number(_this.page.rows[i].mxsl) !== 0 && Number(_this.page.rows[i].mxsl) !== Number(_this.page.rows[i].jcds)) {
              _this.page.rows[i].jcjg = '不合格';
            }
          }

          if (_this.page.pageNo < _this.page.totalPages) {
            _this.isMore = true;
            _this.isDisabled = false;
          }
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此任务：${_row.infoName}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        jcxService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      jcxService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.$route.params.xmId;
    this.refreshSearch();
  }
};
</script>
